import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@gearbox-protocol/deploy-tools-ui";
import MultiInput from "components/forms/MultiInput";
import type { FC } from "react";
import type { ControllerRenderProps } from "react-hook-form";

import type { ForkSchema } from "../schema";

interface ScriptArgsLiteProps {
  field: ControllerRenderProps<ForkSchema, `scripts.${number}.args`>;
}

const ScriptArgsLite: FC<ScriptArgsLiteProps> = ({ field }) => {
  return (
    <FormItem className="flex flex-row items-center">
      <FormLabel className="w-24">Script Args</FormLabel>
      <FormControl className="ml-2">
        <MultiInput field={field} className="h-8" placeholder="script id" />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};

export default ScriptArgsLite;
